<div class="flex flex-col">
    <div class="text-lg font-bold text-gray-600 break-words">{{label}}</div>
    <div class="flex align-items-center gap-2 mt-1">
        <div class="text-base font-normal text-gray-9 break-words">{{displayValue}}</div>
        @if (claims.includes(PERMISSION.UNMASK_CARD_NUMBER)) {
        <p-button *ngIf="showToggle" [icon]="isToggled ? 'pi pi-eye-slash' : 'pi pi-eye'" [rounded]="true" [text]="true"
            size="small" (click)="toggleVisibility()" title="Toggle Visibility">
        </p-button>
        }
    </div>
</div>